var DialogView = require('dialogview');
var Overlay = require('overlay');


var OverlayContainerView = DialogView.extend({
    tagName: 'div',
    className: 'overlaycontainer',
    initialize: function (options) {
        this.session = options.session;
        _.bindAll(this, 'clearOverlays', 'hide');
        this.afterHide = this.clearOverlays;
        this.hideInstant = true;
        this.showInstant = true;
        this.closeTimer = null;
        this.keepOverlayOpen = false;
        
        this.closeTimeout = null;
        
        $(window).on('beforeunload', this.hide);
        
        this.messages = [];
        this.classNames = [];
        this.overlays = [];
    },
    events: {
        'buttonClick button.close': 'clickDone',
        'mousemove': 'mouseMove'
    },
    render: function () {
        this.contents = $('<div class="overlaycontents">');
        this.done = $('<button type="button" class="close"><span></span></button>');
        $(this.el).append(this.done);
        $(this.el).append(this.contents);
        
        return this;
    },
    _hideEsc: function () {
        this.cancel();
    },
    clickDone: function (e) {
        this.cancel();
        return false;
    },
    cancel: function () {
        _.each(this.overlays, function (o, i) {
            if (o.onCancel) {
                o.onCancel();
            }
        }, this);
        this.hide(true, true);
    },
    mouseMove: function (e) {
        if (!this.keepOverlayOpen) {
            this.keepOverlayOpen = true;
            this.clearCloseTimer();
        }
    },
    clearOverlays: function () {
        _.each(this.messages, function (message, i) {
            $(this.el).removeClass('overlay_container_type_' + message.type);
        }, this);
        _.each(this.classNames, function (className, i) {
            $(this.el).removeClass('overlay_container_class_' + className);
        }, this);
        $(this.el).removeClass('overlay_container_prompt');
        $(this.el).removeClass('overlay_container_head');
        
        this.clearCloseTimer();
        this.keepOverlayOpen = false;
        this.classNames = [];
        this.messages = [];
        this.closeTimeout = null;
        
        if (this.contents) {
            this.contents.empty();
        }
        _.each(this.overlays, function (o, i) {
            o.unbind();
            o.stopListening();
        }, this);
        this.overlays = [];
    },
    markAsRead: function () {
        // Update buffer seen for messages
        var lastSeenMap = {};
        var buffers = {};
        // This avoids calling setLastSeen for every message in a contiguous sequence
        // we only set it once at the end for the latest in the first contiguous sequence
        // of important events that immediately follows the current last seen.
        _.each(this.messages, function (message, i) {
            var cid = message.cid;
            var bid = message.bid;
            var eid = message.eid;
            if (cid < 0 || bid < 0 || eid < 0) {
                return;
            }
            var connection = this.session.getConnection(message.cid);
            if (!connection) {
                return;
            }
            var buffer = connection.getBuffer(bid);
            if (!buffer) {
                return;
            }
            buffers[bid] = buffer;
            var currentMessage = buffer.getMessage(eid);
            if (!currentMessage) {
                return;
            }
            var previous = currentMessage.previousMessage();
            var prevIndex = i-1;
            var precedingMessage = this.messages[prevIndex];
            while (precedingMessage && precedingMessage.bid != bid && prevIndex) {
                precedingMessage = this.messages[--prevIndex];
            }
            if (precedingMessage && i && lastSeenMap[bid] && (lastSeenMap[bid].equals(previous) || !buffer.countImportantMessagesBetween(buffer.getMessage(precedingMessage.eid), currentMessage))) {
                // Use the latest in any contiguous sequence of messages
                lastSeenMap[bid] = currentMessage;
            } else {
                // If this message immediately follows the last seen, or if there are no
                // important messages in between, we can mark it as read
                var lastSeen = buffer.getLastSeenMessage();
                if (!lastSeen || lastSeen.equals(previous) || !buffer.countImportantMessagesBetween(lastSeen, currentMessage)) {
                    lastSeenMap[bid] = currentMessage;
                }
            }
        }, this);
        // Actually set the last seen points for each buffer
        for (var bid in lastSeenMap) {
            buffers[bid].setLastSeen(lastSeenMap[bid]);
        }
    },
    hide: function (animate, markAsRead) {
        if (markAsRead) {
            this.markAsRead();
        }
        if (animate) {
            $(this.el).slideUp('fast', _.bind(function () {
                DialogView.prototype.hide.call(this);
            }, this));
        } else {
            $(this.el).hide();
            DialogView.prototype.hide.call(this);
        }
    },
    setCloseTimer: function () {
        if (this.closeTimeout && !this.keepOverlayOpen) {
            this.clearCloseTimer();
            if (this.session.isFocused()) {
                this.closeTimer = setTimeout(
                    _.bind(this.hide, this, true),
                    this.closeTimeout
                );
            } else {
                setTimeout(_.bind(this.setCloseTimer, this), 1000);
            }
        } else if (this.closeTimeout === false) {
            this.clearCloseTimer();
        }
    },
    clearCloseTimer: function () {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    },
    focusDone: function () {
        this.done.focus();
    },
    getLastMessage: function () {
        return this.messages[this.messages.length - 1];
    },
    shouldAppendHead: function (overlay) {
        // No head
        if (!overlay.head) {
            return false;
        }
        
        // Show if this overlay has no message
        var message = overlay.message;
        if (!message || !message.bid) {
            return true;
        }
        // Show if there was no previous message
        var lastMessage = this.getLastMessage();
        if (!lastMessage || !lastMessage.bid || !lastMessage) {
            return true;
        }
        // Show if this message was for a different buffer to the last
        if (lastMessage.bid != message.bid) {
            return true;
        }
        // Show if this message is of a different type to the last
        if (lastMessage.type != message.type) {
            return true;
        }
        // Show if this message is from a different sender than the last
        if (lastMessage.from != message.from) {
            return true;
        }

        // Show if this overlay should always include the head
        if (_.contains(Overlay.alwaysShowHead, message.type)) {
            return true;
        }
    },
    append: function (overlay) {
        // Skip to the end of any hide animations, so they don't clear this one on complete
        $(this.el).stop(true, true);

        this.closeTimeout = overlay.timeout;
        
        if (!this.keepOverlayOpen) {
            this.setCloseTimer();
        }
        
        var shouldClear = overlay.shouldClearPrevious(_.last(this.overlays));
        if (shouldClear) {
            this.clearOverlays();
        }
        
        var wrapper = $('<div>');
        
        var message = overlay.message;
        if (message) {
            wrapper.addClass('overlay_type_' + message.type);
            $(this.el).addClass('overlay_container_type_' + message.type);
        }
        if (overlay.prompt) {
            wrapper.addClass('overlay_prompt');
            $(this.el).addClass('overlay_container_prompt');
        }
        if (overlay.className) {
            this.classNames.push(overlay.className);
            wrapper.addClass('overlay_class_' + overlay.className);
            $(this.el).addClass('overlay_container_class_' + overlay.className);
        }
        if (this.shouldAppendHead(overlay)) {
            var head = overlay.makeHead();
            wrapper.append(head);
            if ($(this.el).hasClass('overlay_container_head')) {
                head.addClass('overlayNewHead');
            } else {
                $(this.el).addClass('overlay_container_head');
            }
        }
        
        if (overlay.doneText === null) {
            this.done.attr('disabled', true).hide();
        } else {
            this.done.find('span').text(overlay.doneText || 'Done');
            this.done.attr('disabled', false).show();
        }
        
        wrapper.append(overlay.makeContent());
        this.contents.append(wrapper);
        
        
        var keepFocus = !!DialogView.open;
        $(this.el).slideDown(100, _.bind(function () {
            if (!overlay.keepFocus && !keepFocus) {
                this.focusDone();
            }
            if (overlay.afterAppend) {
                overlay.afterAppend();
            }
        }, this));
        this.show(true);
        
        if (message) {
            this.messages.push(message);
        }
        overlay.bind('clear', function () {
            this.hide(false, true);
        }, this);
        overlay.bind('cancel', function () {
            this.cancel();
        }, this);
        overlay.bind('hide', function () {
            this.hide(true, true);
        }, this);
        this.overlays.push(overlay);
    }
});


module.exports = OverlayContainerView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/overlaycontainerview.js
// module id = f01x
// module chunks = 1